// extracted by mini-css-extract-plugin
export default {"image":"OW-z","loaded":"PW-z"};